import { render, staticRenderFns } from "./simpleForm.vue?vue&type=template&id=c2f522fc&"
import script from "./simpleForm.vue?vue&type=script&lang=js&"
export * from "./simpleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports